module.exports = __webpack_public_path__ + "img/most-purchased.ec03cb16.png";